'use strict';

import * as dom from '../lib/dom.js';
import  imagesLoaded  from 'imagesloaded';
import simpleParallax from 'simple-parallax-js';

let instancesParalaxUp = [];
let instancesParalaxDown = [];

function resizeGridItem(item){
   let grid = document.getElementsByClassName("c-tab-podcast__card-content")[0];
   let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
   let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
   let rowSpan = Math.ceil((item.querySelector('.c-card-podcast').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));

   item.style.gridRowEnd = "span "+rowSpan;
}

function resizeAllGridItems(){
   const allItems = document.getElementsByClassName("js-grid-item");
   for(let x=0;x<allItems.length;x++){
      resizeGridItem(allItems[x]);
   }
}

function getAnchor() {
    var currentUrl = document.URL,
    urlParts   = currentUrl.split('#');

    return (urlParts.length > 1) ? urlParts[1] : null;
}

export default function(){
    window.addEventListener('turbolinks:load', function() {
        const bodyEl = document.querySelector('body');
        console.log(dom.hasClass(bodyEl, 'single-podcasts'));
        if (dom.hasClass(bodyEl, 'tax-shows') || dom.hasClass(bodyEl, 'single-podcasts') || dom.hasClass(bodyEl, 'post-type-archive-podcasts') || dom.hasClass(bodyEl, 'page-template-page-all-shows-ep')) {
            resizeAllGridItems();

            const allItems = document.getElementsByClassName("js-grid-item");
            for(let x=0;x<allItems.length;x++){
               imagesLoaded( allItems[x], resizeInstance);
            }

            function resizeInstance(instance){
               const item = instance.elements[0];
               resizeGridItem(item);

            const imagesParallaxUp = document.querySelectorAll('.js-parallax-up');
            const imagesParallaxDown = document.querySelectorAll('.js-parallax-down');

            const windowWidth = window.innerWidth;
            
            if(windowWidth < 1023){ 
                return
            }

            if (imagesParallaxUp) {
                if (imagesParallaxUp.length > 0) {
                    let countimagesParallaxUp = 0;
                    dom.forEachEl(imagesParallaxUp, (image) => {
                        console.log(image);
                        instancesParalaxUp[countimagesParallaxUp] = new simpleParallax(image, {
                            orientation: 'up',
                            scale: 1.2,
                            transition: 'ease',
                        });
                        countimagesParallaxUp++;
                    });
                }
                

                if (imagesParallaxDown.length > 0) {
                    let countimagesParallaxDown = 0;
                    dom.forEachEl(imagesParallaxDown, (image) => {
                        instancesParalaxDown[countimagesParallaxDown] = new simpleParallax(image, {
                            orientation: 'down',
                            scale: 1.2,
                            transition: 'ease',
                        });
                        countimagesParallaxDown++;
                    });
                }
            }
            
            
            }
        }
        console.log(getAnchor());
        if (getAnchor() == 'anchor-tabs') {

            setTimeout(function () {
                console.log('smooth scrolllllllllll');
                const targetToScroll = document.querySelector('#anchor-tabs');
                console.log(targetToScroll);
                window.scroll({
                  top: targetToScroll.offsetTop,
                  left: 0,
                  behavior: 'smooth'
                });
            },850);
        }

        const NavPodcastItems = document.querySelectorAll('.js-control-podcast-nav li:not(.nav-apoie) a' );
        if (NavPodcastItems.length > 0) {
            NavPodcastItems.forEach((el)=>{
                el.addEventListener ('click', function(e) {
                    dom.forEachEl(instancesParalaxUp, (instance) => {
                        // instance.destroy();
                    });
    
                    dom.forEachEl(instancesParalaxDown, (instance) => {
                        // instance.destroy();
                    });
                });
        
            });
        }

    });

    window.addEventListener('resize', function() {
        const bodyEl = document.querySelector('body');
        console.log(dom.hasClass(bodyEl, 'single-podcasts'));
        if (dom.hasClass(bodyEl, 'tax-shows') || dom.hasClass(bodyEl, 'single-podcasts') || dom.hasClass(bodyEl, 'post-type-archive-podcasts') || dom.hasClass(bodyEl, 'page-template-page-all-shows-ep')) {
            resizeAllGridItems();

            const allItems = document.getElementsByClassName("js-grid-item");
            for(let x=0;x<allItems.length;x++){
               imagesLoaded( allItems[x], resizeInstance);
            }

            function resizeInstance(instance){
               const item = instance.elements[0];
               resizeGridItem(item);
            }
        }

        

    });
}
